var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column",staticStyle:{"height":"100%"}},[_vm._m(0),_c('FooterView')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row justify-center my-10 md:my-40"},[_c('span',{staticClass:"text-5xl md:text-9xl font-bold p-8",staticStyle:{"color":"#FFA140"}},[_vm._v("Coming Soon")])])
}]

export { render, staticRenderFns }